import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/store/authStore';

export function NotFoundPage() {
  const { t } = useTranslation();
  const { isAuthenticated, role } = useAuthStore();
  const home = !isAuthenticated ? '/login' : role === 'student' ? '/student' : '/parent';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <div className="text-5xl">📚</div>
      <h1 className="text-2xl font-bold text-gray-900">{t('not_found.title')}</h1>
      <p className="max-w-sm text-gray-500">{t('not_found.desc')}</p>
      <Link
        to={home}
        className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-700 focus:ring-offset-2"
      >
        {t('error_boundary.go_home')}
      </Link>
    </div>
  );
}
